const Theme = {
  style: {
    border_radius: '4px',
  },
  shadow: {
    modal: '0 42px 35px -24px rgba(0, 0, 0, 0.5)',
    card: '0px 4px 12px rgba(0, 0, 0, 0.05)',
    mobileSemiModal: '0px -8px 16px rgba(0, 0, 0, 0.1)',
    dropdown: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    cardHover: '0px 24px 15px -14px rgba(0, 0, 0, 0.1)',
  },
  animation: {
    content_cubic_bezier: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    modal_cubic_bezier: 'cubic-bezier(0, 1.02, 0.41, 1)',
  },
  landingGrid: '1200px',
};

export default Theme;
